export const getSearchResultsMessage = (count: number): string =>
  count === 0 ? 'No data found' : `Table updated with ${count} result${count === 1 ? '' : 's'}`;

export const getSelectSearchResultsMessage = (count: number): string =>
  count === 0 ? 'No results found' : `${count} result${count === 1 ? '' : 's'} found`;
